module.exports = __webpack_public_path__ + "img/infra4.c3ce65df.png";